import { Tag } from "antd";
import { ColumnsType } from "antd/es/table";
import React from "react";

import { AmenityIconImage } from "./AmenityIconImage";
import { CatalogueId, MarketingConfigurationItem, isAmenityCatalogue, isIconUploadCatalogue } from "./types";

const iconColumn: ColumnsType<MarketingConfigurationItem>[number] = {
  title: "ICON",
  dataIndex: "url",
  key: "url",
  width: 80,
  render: (url?: string) => (url ? <AmenityIconImage src={url} size={32} /> : null),
};

const statusColumn: ColumnsType<MarketingConfigurationItem>[number] = {
  title: "STATUS",
  dataIndex: "isActive",
  key: "isActive",
  width: 120,
  render: (isActive: boolean) => (
    <Tag
      style={{
        textTransform: "lowercase",
        borderRadius: 12,
        padding: "0 10px",
        border: "1px solid",
        borderColor: isActive ? "#A2D69E" : "#C0C0C0",
        backgroundColor: isActive ? "#E8F5E9" : "#F4F4F4",
        color: isActive ? "#1C5D3B" : "#767676",
      }}
    >
      {isActive ? "active" : "inactive"}
    </Tag>
  ),
};

export function getColumnsForCatalogue(catalogueId: CatalogueId): ColumnsType<MarketingConfigurationItem> {
  if (isAmenityCatalogue(catalogueId)) {
    return [
      ...(isIconUploadCatalogue(catalogueId) ? [iconColumn] : []),
      { title: "LABEL", dataIndex: "label", key: "label" },
      statusColumn,
    ];
  }

  if (catalogueId === "viewingDaysConfig") {
    return [{ title: "LABEL", dataIndex: "label", key: "label" }, statusColumn];
  }

  if (catalogueId === "viewingTimeSlotsConfig") {
    return [
      { title: "START TIME", dataIndex: "startTime", key: "startTime" },
      { title: "END TIME", dataIndex: "endTime", key: "endTime" },
      statusColumn,
    ];
  }

  return [
    { title: "LABEL", dataIndex: "label", key: "label" },
    { title: "ORDER", dataIndex: "order", key: "order", width: 90 },
    statusColumn,
  ];
}
